import React from 'react'
import { IProps } from './Interface'
import { Balloon, Input } from 'components'
import { Corner } from 'components/balloon'
import { Typography, Box, useMediaQuery } from '@material-ui/core'
import useStyles from './Styles'
import cx from 'classnames'
import { theme } from 'config/constants/theme/theme'
import handleEnterKey from 'utils/handle-enter-key'

const DidYouKnow: React.FC<IProps> = ({
  title,
  answer,
  answerTitle,
  corner,
  bgColor,
  disabled,
  showInputTitle,
  handleConfirm,
  handleConfirmTitle,
  handleInputChange,
  handleInputTitleChange,
  answerPlaceholder,
  answerTitlePlaceholder,
  questionKey,
  sanitizeTitle,
  sanitizeAnswer,
  onInputClick,
  onInputTitleClick,
  inputRefTitle,
  inputRefAnswer,
  onMouseEnter,
  onFocus,
  error
}) => {
  const classes = useStyles({
    corner,
    bgColor,
    disabled
  })
  const fullFilledInput = answer && `${answer}`.length > 60
  const fullFilledInputFontSize = showInputTitle ? 14 : 15
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const balloonSize = downMd ? 270 : 235

  const doSanitizeAnswer = (currentValue: any, newValue: any) => {
    const sanitizedNewValue = newValue.replace(/(\r\n|\n|\r)/gm, '')
    return sanitizeAnswer ? sanitizeAnswer(currentValue, sanitizedNewValue) : sanitizedNewValue
  }

  return (
    <Balloon corner={corner} bgColor={bgColor} size={balloonSize}>
      <Box pt={5} px={4} className={classes.content}>
        <Typography id={`did-you-know-${title.replace(/[^A-Z0-9]/gi, '-')}-label`} className={classes.title}>
          {title}
        </Typography>
        {showInputTitle && (
          <Input
            inputRef={inputRefTitle}
            autoFocus={false}
            displayHover={false}
            {...(disabled ? { disabled } : {})}
            textColor={'#FFF'}
            id={`did-you-know-${questionKey}-title`}
            showLimit={false}
            multiline={true}
            limit={6}
            rows={0}
            rowsMax={4}
            textSize={18}
            onBlur={event => handleConfirmTitle(event.target.value)}
            onKeyPress={handleEnterKey((value: any) => handleConfirmTitle(value))}
            sanitizeValue={sanitizeTitle}
            placeholder={!disabled ? answerTitlePlaceholder : ''}
            initialValue={`${answerTitle}`}
            onChanged={handleInputTitleChange}
            className={classes.input}
            onClick={onInputTitleClick}
            onMouseEnter={onMouseEnter}
          />
        )}
        <Input
          inputRef={inputRefAnswer}
          autoFocus={false}
          displayHover={false}
          {...(disabled ? { disabled } : {})}
          textSize={fullFilledInput ? fullFilledInputFontSize : 16}
          multiline={true}
          id={`did-you-know-${questionKey}-answer`}
          showLimit={false}
          textColor={'#FFF'}
          limit={100}
          rows={0}
          rowsMax={6}
          sanitizeValue={doSanitizeAnswer}
          placeholder={!disabled ? answerPlaceholder : ''}
          initialValue={answer}
          onChanged={handleInputChange}
          onBlur={event => handleConfirm(event.target.value)}
          onKeyPress={handleEnterKey((value: any) => handleConfirm(value))}
          className={cx(classes.input, {
            [classes.inputError]: !!error
          })}
          onClick={onInputClick}
          onMouseEnter={onMouseEnter}
          onFocus={onFocus}
        />
      </Box>
    </Balloon>
  )
}

DidYouKnow.defaultProps = {
  title: '',
  answer: '',
  answerTitle: '',
  corner: Corner.BottomLeft,
  bgColor: '#2d4ba2',
  showInputTitle: false,
  answerPlaceholder: 'Enter text',
  answerTitlePlaceholder: 'Enter text',
  handleConfirm: () => {},
  handleConfirmTitle: () => {},
  handleInputChange: () => {},
  handleInputTitleChange: () => {},
  questionKey: '',
  onInputClick: () => {},
  onInputTitleClick: () => {}
}

export default DidYouKnow
